import React from "react";
import Header from "../../components/common/Header";
import SideImage from "../../components/Signup/SideImage";
import SignupForm from "../../components/Signup/SignupForm";

const SignupPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex flex-col lg:flex-row flex-1 pt-[72px]">
        <SideImage />
        <SignupForm />
      </div>
    </div>
  );
};

export default SignupPage;